import { SET_GENERAL_SETTING, GENERAL_SETTING_REQUEST, GENERAL_SETTING_REQUEST_FAILURE } from "../types";

const initialState = {
  generalSetting: {},
  loading: false,
  error: null,
};

const generalSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_SETTING_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case SET_GENERAL_SETTING: {
      return {
        ...state,
        generalSetting: { ...action.payload },
        loading: false,
        error: null
      }
    }
    case GENERAL_SETTING_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default generalSettingReducer;